import { render, staticRenderFns } from "./benefits-tier-chip.vue?vue&type=template&id=48a9e1ce&scoped=true"
import script from "./benefits-tier-chip.vue?vue&type=script&lang=js"
export * from "./benefits-tier-chip.vue?vue&type=script&lang=js"
import style0 from "./benefits-tier-chip.vue?vue&type=style&index=0&id=48a9e1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9e1ce",
  null
  
)

export default component.exports